export const GET_LOADING_TYPE = 'loading';
export const GET_REGENERATE_PROBLEMATIC_REPORTS_TYPE = 'regenerate-problematic-reports';